// Enums
import { EnvName } from '@enums/environment.enum';

// Packages
import packageInfo from '../../package.json';

export const environment = {
  production: false,
  version: packageInfo.version,
  appName: 'Navigator',
  envName: EnvName.DEV,
  defaultLanguage: 'it',
  apiBaseUrl: 'https://api.navigator.dev.s-marketing.ch',
  instanceUuid: 'd3d67e10-c896-11f1-8558-0e6b4eaa0fa5',
  gaId: 'G-7SRR4FL8E7',
};
